// file: src/auth/AuthContext.jsx
import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { clearAuth, setAuth, getToken, getUser } from "../api/adminApi";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [adminUser, setAdminUser] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    // bootstrap from storage (admin-only keys)
    const token = getToken();
    const u = getUser();
    setAdminUser(token && u ? u : null);
    setReady(true);

    const onStorage = () => {
      const t = getToken();
      const user = getUser();
      setAdminUser(t && user ? user : null);
    };

    const onExpired = (e) => {
      // Only clear admin state; DO NOT navigate here.
      // Global watcher (session.js) handles the single redirect by source.
      try {
        clearAuth();
      } catch {}
      setAdminUser(null);
    };

    window.addEventListener("storage", onStorage);
    window.addEventListener("auth:expired", onExpired);

    return () => {
      window.removeEventListener("storage", onStorage);
      window.removeEventListener("auth:expired", onExpired);
    };
  }, []);

  const value = useMemo(
    () => ({
      adminUser,
      ready,
      login: (payload, persistent = true) => {
        setAuth(payload, persistent);
        setAdminUser(payload || null);
      },
      logout: () => {
        // Only clear admin; let caller/route decide where to go or rely on global watcher.
        try {
          clearAuth();
        } catch {}
        setAdminUser(null);
      },
    }),
    [adminUser, ready]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}
